// extracted by mini-css-extract-plugin
export default {"pageWrapper":"OrozinoSlots_pageWrapper__qbPjd"};